import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import apiClient, { getErrorMessage } from '../../api/client';
import { useToast } from '../../hooks/useToast';
import { FiCheck } from 'react-icons/fi';

const Notifications = () => {
  const { error: showError } = useToast();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadAll = () => {
    setLoading(true);
    apiClient.get('/comms/notifications/me')
      .then(({ data }) => setNotifications(data.data))
      .catch((err) => showError(getErrorMessage(err, 'Could not load notifications')))
      .finally(() => setLoading(false));
  };

  useEffect(loadAll, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleMarkRead = async (id) => {
    try {
      await apiClient.patch(`/comms/notifications/me/${id}/read`);
      loadAll();
    } catch (err) { showError(getErrorMessage(err, 'Could not mark as read')); }
  };

  return (
    <motion.div className="dashboard-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
      <div className="page-header">
        <h1>Notifications</h1>
        <p>Your in-app notifications</p>
      </div>
      <section className="page-section">
        <div className="table-container">
          <table className="data-table">
            <thead><tr><th>Title</th><th>Body</th><th>Channel</th><th>Status</th><th>Date</th><th></th></tr></thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} style={{ textAlign: 'center', padding: '2rem' }}>Loading...</td></tr>
              ) : notifications.length === 0 ? (
                <tr><td colSpan={6} style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>No notifications</td></tr>
              ) : notifications.map((n) => (
                <tr key={n.id} style={{ background: n.readAt ? 'transparent' : '#eff6ff' }}>
                  <td style={{ fontWeight: n.readAt ? 400 : 700 }}>{n.title}</td>
                  <td>{n.body || '—'}</td>
                  <td style={{ textTransform: 'capitalize' }}>{n.channel?.replace('_', ' ')}</td>
                  <td><span className="badge" style={{ background: n.status === 'sent' ? '#10b981' : n.status === 'failed' ? '#ef4444' : '#f59e0b', color: 'white' }}>{n.status}</span></td>
                  <td>{new Date(n.createdAt).toLocaleDateString()}</td>
                  <td>
                    {!n.readAt && (
                      <button className="action-icon edit" title="Mark read" onClick={() => handleMarkRead(n.id)}>
                        <FiCheck size={16} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </motion.div>
  );
};

export default Notifications;